<template>
  <div class="margin-t-b">
    <div v-if="isFlexibleILOs">
      <div v-if="ilos && Object.keys(ilos).length" class="field-data">
        <span class="text-subtitle-1 font-weight-bold secondary--text">
          {{ $t('ILOS') }} :
        </span>
        <v-treeview
          :items="ilos as any[]"
          class="wrappable-tree"
          open-all
          :open="openNodes"
          @update:open="openNodes = $event"
        >
          <template v-slot:prepend="{ item }"> {{ item.ilo_code }} )
          </template>
        </v-treeview>
      </div>
    </div>
    <div v-else>
      <div
        v-for="(ilosArray, headerKey) in ilos"
        :key="headerKey"
        class="field-data"
      >
        <span
          v-if="ilosArray && ilosArray.length"
          class="field-data text-subtitle-1 font-weight-bold"
          style="text-decoration: underline"
        >
          {{ $utils.servertranslate(ilosArray[0].header) }}
        </span>

        <div
          v-for="(ilo, iloIndex) in ilosArray"
          :key="iloIndex"
          class="field-data px-2"
        >
          <span class="d-inline-block ltr font-weight-bold">{{ ilo.iloCode }}</span> <span class="text-subtitle-2 font-weight-bold">) {{ ilo.ilo }}</span>
          <div
            v-for="(sub, subIndex) in ilo.subIlos || []"
            :key="subIndex"
            class="field-data"
          >
            <span class="d-inline-block ltr">{{ sub.subIloCode }}</span> <span class="text-subtitle-2">) {{ sub.subIlo }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HeaderILos } from '@/types/ilos.type';

export default defineComponent({
  name: 'IlosViewComponent',
  props: {
    ilos: {
      type: Object as () => HeaderILos,
      default: () => ({}),
    },
    isFlexibleILOs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openNodes: [] as string[],
    };
  },
  methods: {
    formatILOCodes(code: string) {
      return ['.', '-'].includes(code.substr(code.length - 1))
        ? code.slice(0, -1)
        : code;
    },
  },
});
</script>

<style scoped>
.field-data {
  margin: 0 10px;
}
</style>
